module.exports = __webpack_public_path__ + "img/default-advanced-room-image.6738d0dc.png";